var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.41421356,11 L8.70710678,15.2928932 C9.09763107,15.6834175 9.09763107,16.3165825 8.70710678,16.7071068 C8.31658249,17.0976311 7.68341751,17.0976311 7.29289322,16.7071068 L1.29289322,10.7071068 C0.902368927,10.3165825 0.902368927,9.68341751 1.29289322,9.29289322 L7.29289322,3.29289322 C7.68341751,2.90236893 8.31658249,2.90236893 8.70710678,3.29289322 C9.09763107,3.68341751 9.09763107,4.31658249 8.70710678,4.70710678 L4.41421356,9 L18,9 C18.5522847,9 19,9.44771525 19,10 C19,10.5522847 18.5522847,11 18,11 L4.41421356,11 Z",
    id: "path-1-arrow"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrowleft",
    transform: "translate(-1.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundaries"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-arrow",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-arrow"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1-arrow",
    fill: "#FFFFFF",
    xlinkHref: "#path-1-arrow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRegular);
export default __webpack_public_path__ + "static/media/ArrowRegular.4e51e3cc93f353cd40608fb73dc53b38.svg";
export { ForwardRef as ReactComponent };